var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#BABDCC",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 2.298c-.055-.055-.13-.087-.208-.087-.078 0-.153.031-.208.086l-6.408 6.41c-.115.115-.115.301 0 .416l2.903 2.903c.114.115.3.115.415 0L11.7 5.62c.114-.114.114-.3 0-.414L8.8 2.298zM1.385 9.817c-.076-.075-.185-.104-.287-.075-.103.029-.181.11-.206.214l-.884 3.683c-.024.1.006.204.078.276.073.071.177.1.276.077l3.68-.88c.103-.025.185-.103.214-.206.03-.102 0-.212-.075-.287L1.385 9.817zM13.572 1.675L12.326.429c-.572-.572-1.5-.572-2.072 0l-.832.831c-.115.115-.115.3 0 .415l2.904 2.904c.115.114.3.114.415 0l.831-.833c.57-.572.57-1.499 0-2.071z",
    transform: "translate(-1128 -565) translate(1128 564) translate(0 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7fd4529b2031c217a8e5db031feea39e.svg";
export { ForwardRef as ReactComponent };